import type { LessonLevel } from '@/components/v2/lesson/lessonVocabulary'

const LESSON_LEVELS: LessonLevel[] = [
  'beginner',
  'elementary',
  'intermediate',
  'advanced',
]

export function getSelectedLanguageCode(): string {
  return localStorage.getItem('selectedLanguage') ?? 'en'
}

/**
 * The answer to the `level-question` step. Defaults to beginner, which is both
 * the safest lesson to show and what the CEFR mapping in `saveOnboardingAnswers`
 * falls back to, so the lesson and the saved profile agree.
 */
export function getSelectedLevel(): LessonLevel {
  const stored = (localStorage.getItem('comfortLevel') ?? '')
    .trim()
    .toLowerCase()

  return LESSON_LEVELS.find((level) => level === stored) ?? 'beginner'
}
